import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { PageResponse } from '@core/shared/domain';

import { HitList } from '../models';

export const HitListsActions = createActionGroup({
  source: 'Medical Shop - HitLists',
  events: {
    'Fetch hit lists': emptyProps(),
    'Fetch hit lists success': props<{ hitLists: PageResponse<HitList> }>(),
    'Fetch hit lists error': emptyProps(),
  },
});
